import PropTypes from "prop-types"
import React from "react"

const DockwaAccountIndicator = ({ linked }) =>
  linked ? (
    <span className="inline-flex items-center gap-1">
      <i className="fa-solid fa-link text-teal-500" />
      <span>Linked</span>
    </span>
  ) : (
    <span className="inline-flex items-center gap-1">
      <i className="fa-solid fa-link-slash text-gray-600" />
      <span>Not linked</span>
    </span>
  )

DockwaAccountIndicator.propTypes = {
  linked: PropTypes.bool.isRequired,
}

export default DockwaAccountIndicator
